import t from '../../translate'
import { Accordion, AccordionItem } from '../../components/accordion'
import React, { useState } from 'react'
import PersonalDataForm from './PersonalDataForm'
import { AddressForm } from './addressForm'
import HealthInsurance from './healthInsurance'
import UniversityEntranceQualification from './universityEntranceQualification'
import Academic from './academic'
import PreviousStudies from './previousStudies'
import Job from './job'
import Payment from './payment'

export default function DataStep ({ countries, healthInsurances, program, errors }) {
  const [activeAccordionId, setActiveAccordionId] = useState("personal-accordion-0"); 
  const {
    noneForEntranceAccepted,
    admissionExamForEntranceAccepted,
  } = program.qualification || {};
  return <div className={'data-step'}>
    <h3>{t('data.personal.title')}</h3>
    <Accordion className={'personal-accordion'} accordionId="personal-accordion" activeAccordionId={activeAccordionId} setActiveAccordionId={setActiveAccordionId}>
      <AccordionItem hasErrors={errors?.data?.personal?.information != undefined} title={t('data.personal.information.header')}>
        <PersonalDataForm countries={countries} errors={errors}/>
      </AccordionItem>
      <AccordionItem hasErrors={errors?.data?.personal?.address != undefined}  title={t('data.personal.address.header')}>
        <AddressForm countries={countries} />
      </AccordionItem>
    </Accordion>
    <h3>{t('data.studies.title')}</h3>
    <Accordion className={'studies-accordion'} accordionId="studies-accordion" activeAccordionId={activeAccordionId} setActiveAccordionId={setActiveAccordionId}>
    <AccordionItem hasErrors={errors?.data?.studies?.academic != undefined}  title={t('data.studies.academic.header')}>
        <Academic program={program} />
      </AccordionItem>
      <AccordionItem hasErrors={errors?.data?.studies?.employment != undefined}  title={t('data.studies.employment.header')}>
        <Job program={program} />
      </AccordionItem>
    </Accordion>
    <h3>{t('data.studies.payment.title')}</h3>
    <Accordion className={'payment-accordion'} accordionId="payment-accordion" activeAccordionId={activeAccordionId} setActiveAccordionId={setActiveAccordionId}>
      <AccordionItem hasErrors={errors?.data?.payment != undefined}  title={t('data.studies.payment.header')}>
        <Payment countries={countries} />
      </AccordionItem>
    </Accordion>
    <p className={'required-info'}>{t('requiredFields')}</p>
  </div>
}
